import React from "react";
import "./NormalUsecase.css";

function NormalUsecaseRight({ imageSrc, header, description }) {
  return (
    <>
      <div className="Normal-right-use-case-outer">
        <div className="Normal-right-use-case-container">
          <div className="Normal-right-case-content">
            <h2>{header}</h2>
            <p>{description}</p>
          </div>
          <div className="Normal-right-use-case-image">
            <img src={imageSrc} alt="Use Case" />
          </div>
        </div>
      </div>
      <hr className="horizontal-line" />
    </>
  );
}

export default NormalUsecaseRight;
